/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import {
  BaSeCheckbox,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';

import { mapTermsConditions } from '../../utils/conditions-term';
import {
  Container,
  Content,
  Description,
  Footer,
  Title,
} from './terms-and-conditions-style';
import { useInterviewContext } from '../../context/interview-context';
import { useValidationsContext } from '../../context/validations-context';

export const TermsAndConditions = () => {
  const { interview } = useInterviewContext();
  const { setTerm, term } = useValidationsContext();

  return (
    <Container>
      <Description>
        Agora que você já conhece mais sobre o seminário e dedicação necessária
        para fazê-lo, por favor, leia o termo a seguir e, caso esteja de acordo,
        clique em continuar.
      </Description>

      <div>
        <Title>
          <h1>Termos e Condições</h1>
        </Title>
        <Content>

          <div
            style={{  margin: '5px 0' }}
          >
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
          Declaração de ciência e responsabilidade para participação no Seminário Empretec
          </BaSeParagraph>
          </div>

          {mapTermsConditions(interview?.module?.id ?? 1).descricoes?.map(
            (desc) => (
              <div
                style={{ display: 'flex', flexDirection: 'column',  marginTop: 12 }}
                key={desc.id}
              >
                <BaSeParagraph
                  isBold
                  color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                >
                  {desc.titulo}
                </BaSeParagraph>
               <div>
                 {desc?.descricao.map((infoDesc) => (
                   <div
                     key={infoDesc}
                     style={{
                       display: 'flex',
                       flexDirection: 'column',
                       margin: '6px 0'
                     }}
                   >
                     <BaSeSmall1
                       color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                     >
                       {infoDesc}
                     </BaSeSmall1>
                   </div>
                 ))}
               </div>
              </div>
            ),
          )}
        </Content>
        <Footer>
          <BaSeCheckbox
            size="small"
            checked={term}
            value={term}
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            onChange={(value) => setTerm(value)}
            label="Estou ciente e de acordo com as informações apresentadas acerca dos termos para participação no Empretec."
          />
        </Footer>
      </div>
    </Container>
  );
};
